import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@common/react/components/Forms/Button';
import { getLocalStorageValue, setLocalStorageValue } from '@common/react/utils/localStorage/localStorage';

import '@app/scss/components/lockContent.scss';

const LockContent: React.FC<{fixed?: boolean}> = ({ fixed }) => {
	const { t } = useTranslation();
	const [lock, setLock] = React.useState(false);

	React.useEffect(() => {
		setLock(JSON.parse(getLocalStorageValue('lock-cases', 'true')));
	}, []);

	const unlock = () => {
		setLocalStorageValue('lock-cases', false);
		setLock(false);
	};

	const [top, setTop] = React.useState(400);
	const ref = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		if (ref.current) {
			const resizeObserver = new ResizeObserver((entries) => {
				typeof window !== 'undefined' && window.requestAnimationFrame(() => {
					for (const entry of entries) {
						const rect = ref.current?.getBoundingClientRect();
						if (rect) {
							setTop(rect.top + (window.innerWidth < 768 ? 40 : 240));
						}
					}
				});
			});

			resizeObserver.observe(ref.current);

			return () => {
				ref.current && resizeObserver.unobserve(ref.current);
			};
		}
	}, [lock]);

	if (!lock) {
		return null;
	}

	const content = (<div className={`lock-content ${fixed ? 'lock-content-fixed' : ''}`} style={{ top }} key="content">
		<h2>
			{t('site.WARNING')}
		</h2>
		<p>
			{t('site.This feature contains nudity')}
		</p>
		<div className="text-center">
			<Button className="btn btn-default" onClick={unlock}>
				OK
			</Button>
		</div>
	</div>);

	return <>
		<div ref={ref} className="lock-container text-center" key="blur">
			{fixed ? null : content}
		</div>
		{fixed ? content : null}
	</>;
};

export default LockContent;
